import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { useContent } from "@/context/ContentContext";
import { useAuth } from "@/context/AuthContext";
import { ScrollToTop } from "./ScrollToTop";
import { OnlineBanner } from "./OnlineBanner";
import { MaintenancePage } from "./MaintenancePage";
import { WelcomeIntro } from "./WelcomeIntro";
import { useReveal } from "@/lib/motion";
import { CustomCursor } from "./CustomCursor";
import { UiSound } from "./UiSound";

export function SiteLayout() {
  const { loading, error, content } = useContent();
  const { user } = useAuth();
  useReveal();
  const maintenance = !!content?.maintenance?.enabled;
  const fx = content?.theme || {};
  if (content && maintenance && user === null) return <div className="min-h-screen bg-eden-bg" />;
  if (content && maintenance && user === false) return <MaintenancePage />;
  return (
    <div className="flex min-h-screen flex-col">
      <WelcomeIntro />
      {fx.cursor !== false && <CustomCursor />}
      {fx.sounds !== false && <UiSound />}
      <a href="#conteudo" className="skip-link">Saltar para o conteúdo</a>
      <ScrollToTop />
      {maintenance && (
        <div className="bg-amber-500 px-4 py-1.5 text-center font-mono text-xs uppercase tracking-widest text-eden-bg" data-testid="maintenance-admin-banner">
          Modo manutenção ativo: os visitantes veem a página de manutenção. Estás a ver o site como administrador.
        </div>
      )}
      <Navbar />
      <OnlineBanner />
      <main id="conteudo" className="flex-1" tabIndex={-1}>
        {loading && <div className="container-eden py-32 text-center text-sm text-eden-muted" role="status">A carregar…</div>}
        {!loading && error && !content && (
          <div className="container-eden py-32 text-center" role="alert" data-testid="content-error">
            <p className="text-eden-secondary">Não foi possível carregar o conteúdo. Tenta novamente dentro de instantes.</p>
          </div>
        )}
        {content && <Outlet />}
      </main>
      <Footer />
    </div>
  );
}
